<template>
  <div id="app" :class="{ 'has-tabbar': showTabBar }">
    <div class="app-view">
      <router-view />
    </div>
    <tab-bar v-if="showTabBar" />
  </div>
</template>

<script>
import TabBar from "@/components/TabBar/TabBar.vue";

const TAB_BAR_ROUTES = ["/", "/discount", "/customer", "/invite", "/setting"];

export default {
  name: "App",
  components: {
    TabBar,
  },
  computed: {
    showTabBar() {
      return TAB_BAR_ROUTES.includes(this.$route.path);
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f4faff;
}

#app {
  width: 100%;
  max-width: 750px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f4faff;
  box-sizing: border-box;
}

.app-view {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.app-view > * {
  height: 100%;
}

div {
  box-sizing: border-box;
}

a:link,
a:visited,
a:hover,
a:active {
  text-decoration: none;
  color: inherit;
  background-color: transparent;
  outline: none;
}

.viewBody {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f4faff;
}

.scroll::-webkit-scrollbar {
  width: 0;
}
</style>
